(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
document.addEventListener('DOMContentLoaded', function () {

  
  
  const languageOptions = document.querySelectorAll('#HeaderLanguageForm span');

  languageOptions.forEach(option => {
    const originalText = option.textContent.trim();

    // Apply the transformation: first two letters in uppercase, rest in lowercase
    if (originalText.length >= 2) {
      const formattedText = originalText.slice(0, 2).toUpperCase();
      option.textContent = formattedText;
    }
  });
  
  const stickyHeader = document.querySelector('sticky-header');

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop === 0) {
      if (stickyHeader) {
        stickyHeader.addEventListener('mouseenter', handleMouseEnter);
        stickyHeader.addEventListener('mouseleave', handleMouseLeave);
      }
    } else {
      if (stickyHeader) {
        stickyHeader.removeEventListener('mouseenter', handleMouseEnter);
        stickyHeader.removeEventListener('mouseleave', handleMouseLeave);
      }
    }
  };

  const handleMouseEnter = () => {
    stickyHeader.classList.remove('main-page-header');
  };

  const handleMouseLeave = () => {
    stickyHeader.classList.add('main-page-header');
  };

    /* --- existing code here --- */

  /* 1. Grab the summary that opens the drawer */
  const menuToggle = document.querySelector(
    'summary.header__icon--summary[aria-controls="menu-drawer"]'
  );
  if (menuToggle) {
  /* 2A.  Easiest: react to the user’s click  -------------------- */
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    open ? handleMouseEnter() : handleMouseLeave();
  });
  /* 2B.  If something else toggles aria-expanded, keep watching -- */
  const observer = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.attributeName !== 'aria-expanded') return;
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      open ? handleMouseEnter() : handleMouseLeave();
    });
  });
  observer.observe(menuToggle, { attributes: true });
  }

  
  /* 1. Grab the summary that opens the drawer */
  const languageMenuToggle = document.querySelector(
    'button.localization-form__select[aria-controls="HeaderLanguageList"]'
  );
  
  /* 2A.  Easiest: react to the user’s click  -------------------- */
  languageMenuToggle.addEventListener('click', () => {
    const open = languageMenuToggle.getAttribute('aria-expanded') === 'true';
    open ? handleMouseEnter() : handleMouseLeave();
  });
  /* 2B.  If something else toggles aria-expanded, keep watching -- */
  const observer2 = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.attributeName !== 'aria-expanded') return;
      const open = languageMenuToggle.getAttribute('aria-expanded') === 'true';
      open ? handleMouseEnter() : handleMouseLeave();
    });
  });
  observer2.observe(languageMenuToggle, { attributes: true });

  window.addEventListener('scroll', handleScroll);
  handleScroll(); // Trigger once on load to set the initial state
});


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop === 0) {
        this.classList.add('main-page-header');
      } else {
        this.classList.remove('main-page-header');
      }
      
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
